/**
 * Modèle représentant l'origine d'un décalage d'intervention
 */
export class ShiftOriginModel {
  /**
   * Identifiant unique de l'origine de décalage
   */
  id: number

  /**
   * Nom de l'origine de décalage
   */
  name: string

  /**
   * Code couleur hexadécimal associé à cette origine
   */
  color: string

  /**
   * Indique si l'origine est liée à un fournisseur d'énergie (1 = oui, 0 = non)
   */
  isNrjOrigin: number

  /**
   * Indique si l'origine est liée au client (1 = oui, 0 = non)
   */
  isCustomerOrigin: number

  constructor(data?: Partial<ShiftOriginModel>) {
    if (data) {
      Object.assign(this, data)
    }
  }

  /**
   * Détermine si cette origine est considérée comme liée à un fournisseur d'énergie
   */
  get isEnergyProvider(): boolean {
    return this.isNrjOrigin === 1
  }

  /**
   * Détermine si cette origine est considérée comme liée au client
   */
  get isCustomer(): boolean {
    return this.isCustomerOrigin === 1
  }
}
